import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import {
    ILoyaltyStock,
    ILoyaltyStockListItem,
    LoyaltyStockResponseType,
} from '@/entity/loyalty/loyaltyStock/LoyaltyStock.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { LoyaltyStockGeneralRequestType } from '@/form/loyalty/loyaltyStock/LoyaltyStockGeneral.types';
import { ResponseDataType } from '@/form/form.types';
//import { createLogger } from 'vuex';
import { prepareFormData } from '@/store/utils/formDataHelper';

@Module({
    namespaced: true,
    name: 'loyaltyStock',
    store,
    dynamic: true,
})
class LoyaltyStockModule extends VuexModule {
    delete(id: number) {
        throw new Error('Method not implemented.');
    }
    loyaltyStocks: ILoyaltyStock | null = null;
    loyaltyStock: ILoyaltyStockListItem | null = null;
    loyaltyStockLoaded = false;
    @MutationAction
    async fetchAll(
        data?: PaginationRequestType
    ): Promise<{ loyaltyStocks: ILoyaltyStock; loyaltyStockLoaded: boolean }> {
        let loyaltyStockLoaded = false;
        const loyaltyStocks = await store.$repository.loyaltyStock.fetchAll(prepareFormData(data));

        if (loyaltyStocks) {
            loyaltyStockLoaded = true;
        }
        return { loyaltyStocks, loyaltyStockLoaded };
    }
    @Action({ rawError: true })
    async create(data: LoyaltyStockGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.loyaltyStock.create(data);
    }
    @Action({ rawError: true })
    async update(data: LoyaltyStockGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.loyaltyStock.update(data);
    }
    /*@MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ salon: ILoyaltyStockListItem  ; counterpartiesLoaded: boolean }> {
        let counterpartiesLoaded = false;
        const salon = await store.$repository.counterparties.fetchData(data);
        if (salon) {
            counterpartiesLoaded = true;
        }
        return { salon, counterpartiesLoaded};
    }
    @Action({rawError: true})
    async create(data: LoyaltyStockGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: LoyaltyStockGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.update(data);
        return resp;
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.delete(data);
        return resp;
    }*/
}

export const LoyaltyStockStore = getModule(LoyaltyStockModule);
